import React from 'react';
import classNames from 'classnames';
import i18next from 'i18next';

import { CoreLink } from '@uncinc/react-drupal-core';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import { WysiwygField } from '../../../../components';

import './style.scss';

const TaxonomyTermThemeTeaserLarge = ({ entity, className }) => {
  const classes = classNames(className, 'Theme', 'TaxonomyTerm', 'TaxonomyTermThemeTeaserLarge');

  const image = entity.getIn(['field_thumbnail', 0, 'styles', 'large'], '');
  const title = entity.getIn(['name', 0, 'value'], '');
  const body = entity.getIn(['description', 0, 'processed'], '');

  return (
    <article typeof="schema:WebPage" className={classes}>
      <CoreLink to={entity.getIn(['paths', 'nl'])} className="overlapping-link" />
      <div className="TaxonomyTermThemeTeaserLarge__imageWrapper">
        <Image
          alt="Image 1"
          lazyload={false}
          src={image}
        />
      </div>
      <div className="TaxonomyTermThemeTeaserLarge__contentWrapper">
        <span className="TaxonomyTermThemeTeaserLarge__subheading">{i18next.t('theme')}</span>
        <h2 className="TaxonomyTermThemeTeaserLarge__heading">{title}</h2>
        <WysiwygField
          property="schema:text"
          className="TaxonomyTermThemeTeaserLarge__body body-intro"
          html={body}
        />
      </div>
    </article>
  );
};

export default TaxonomyTermThemeTeaserLarge;
